module.exports = __webpack_public_path__ + "static/img/on-job-nodata.ee54df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/on-job/on-job-nodata.png
// module id = oImL
// module chunks = 4